
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"bc8160e1-8f8d-4da6-b183-8d781b72cc82","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"a67147e8-705d-48a2-a8df-769b3d5a48af"}},[_c('g',{attrs:{"data-name":"b1b9b279-0f41-439b-a972-7701b6d54e37"}},[_c('g',{attrs:{"data-name":"a1e4d3cc-4d21-403c-b7fd-ece67cfc2202"}},[_c('path',{attrs:{"data-name":"f620965a-7823-4d0a-9746-548ac1add1c6","d":"M22.55 6.72a5.24 5.24 0 01-5.25-5.2h-3.94v15.09a3.21 3.21 0 11-3.24-3.18 3.77 3.77 0 011 .14v-4a8.4 8.4 0 00-1-.07 7.08 7.08 0 107.15 7.08v-8a8.3 8.3 0 005.25 1.85z","fill-rule":"evenodd","fill":"#ff0b53"}})]),_c('path',{attrs:{"data-name":"a6e85be8-7178-49c0-8642-7a7a8103d547","d":"M21.25 5.41A5.23 5.23 0 0116 .22h-3.95V15.3a3.21 3.21 0 11-3.25-3.17 3.77 3.77 0 011 .14v-4a6.73 6.73 0 00-1-.07 7.07 7.07 0 107.2 7.1v-8a8.39 8.39 0 005.26 1.85z","fill":"#00f0e9","fill-rule":"evenodd"}}),_c('path',{staticClass:"lime-fill",attrs:{"data-name":"b18f109e-07e1-457c-b70c-7797083e7f33","d":"M21.25 6.66a5.21 5.21 0 01-3.09-2 5.28 5.28 0 01-2-3.12h-2.91v15.23a3.17 3.17 0 01-5.9 1.65 3.21 3.21 0 011.62-6 3.77 3.77 0 011 .14v-3a7.17 7.17 0 00-5.42 11.68A7 7 0 009 22.81a7.11 7.11 0 007.08-7.14V7.58a8.15 8.15 0 005.2 1.87z","fill":"#fff","fill-rule":"evenodd"}})])])])
          )
        }
      }
    